'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BibItemInfo = require('./components/BibItemInfo.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BibItemInfo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/bib-item-info/index.js
// module id = 917
// module chunks = 0